import React, {Component} from 'react';
import {Link, Redirect, withRouter} from 'react-router-dom';
import $ from "jquery";
import db from "../dbconn";
import fetch from "isomorphic-fetch";
import {API_ROOT} from "../api-config";
import Modal from 'react-responsive-modal';
import {withTranslation} from 'react-i18next';
import i18n from '../i18n';


class accountSetup extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            redirect: false,
            windowHeight: 0,
            buildItemFlag: false,
            categoryList: [],
            open: false,
            nosessionredirect: false,
            custname: ''
        };
        this.updateState = this.updateState.bind(this);


    };

    updateState(e) {
        this.setState({});

    }

    onOpenModal = () => {
        this.setState({open: true});

    };
    onCloseModal = () => {
        this.setState({open: false});
    };

    componentWillMount() {

        if(!localStorage.getItem("store_language")){
            localStorage.setItem("store_language","en")
        }
        i18n.changeLanguage(localStorage.getItem("store_language")).then(r => {
        });
        var categroyUrl = '';

        if (sessionStorage.getItem('guestFlag') == 'Y') {
            categroyUrl = API_ROOT + '/fetchcategorylist?guestFlag=Y&store_id=' + localStorage.getItem('store_id');

            fetch(categroyUrl)
                .then(response => {
                    return response.json();
                })
                .then(categoryData => {

                    this.onCloseModal();
                    if (categoryData.status == 1) {
                        this.setState({categoryList: categoryData.category_data});

                        var nav = window.$('#nav-main').okayNav();
                        nav.okayNav('recalcNav');
                    }
                });
        } else {
            var dbconn = new db();

            dbconn.getAll().then(data => {
                if (!data || data.length < 1) {
                    this.setState({nosessionredirect: true});
                } else {
                    var customer_id = data[0].customer_id;
                    var customer_token = data[0].customer_token;
                    var customer_firstname = data[0].customer_firstname;
                    this.setState({custname: customer_firstname});
                    categroyUrl = API_ROOT + '/fetchcategorylist?customer_id=' + customer_id + '&customer_token=' + customer_token + '&store_id=' + localStorage.getItem('store_id');

                    fetch(categroyUrl)
                        .then(response => {
                            return response.json();
                        })
                        .then(categoryData => {

                            this.onCloseModal();
                            if (categoryData.status == 1) {
                                this.setState({categoryList: categoryData.category_data});

                                var nav = window.$('#nav-main').okayNav();
                                nav.okayNav('recalcNav');
                            }
                        });
                }
            });
        }
    }

    componentDidMount() {


        document.title = "My Account - " + localStorage.getItem("store_name") + " - Tria Commerce";
        var primaryColor = localStorage.getItem("store_primary_color");

        if (primaryColor != null) {
            document.documentElement.style.setProperty('--primaryColor', primaryColor);
        }
        var secondaryColor = localStorage.getItem("store_secondary_color");


        if (secondaryColor != null) {
            document.documentElement.style.setProperty('--secondaryColor', secondaryColor);
        }

        var lightColor = localStorage.getItem("store_light_color");

        if (lightColor != null) {
            document.documentElement.style.setProperty('--lightColor', lightColor);
        }


        var buttonColor = localStorage.getItem("store_button_color");

        if (buttonColor != null) {
            document.documentElement.style.setProperty('--buttonColor', buttonColor);
        }


        var height = $(window).height();
        this.setState({windowHeight: height});
    }

    logout = () => {

        var dbconn = new db();

        dbconn.deleteAll();
        dbconn.deleteAllOrder();
        localStorage.removeItem("remember");

        this.setState({nosessionredirect: true});
    };

    render() {

        const {open} = this.state;
        const {t} = this.props;

        if (this.state.nosessionredirect) {
            return (<Redirect to={'/'}/>);
        }

        return (
            <div className="mainContainer">

                <header>
                    <div className="col-md-12 col-sm-12 col-xs-12 previous-link">
                        <Link to={'/menu'}></Link>
                        <h2 className="text-center">{t('my_account')}</h2>
                    </div>
                </header>
                <div className="clearfix"></div>
                <div className="h-100" style={{top: "45px", position: "relative"}}>
                    <div className="simple-box account-box h-100 m-b-10">
                        <form name="" className="" method="post" encType="multipart/form-data" action="#">
                            <div className="header-title m-t-20 m-b-0">
                                <h2 className="text-center">{t('hi')} {this.state.custname}!</h2>
                            </div>
                            <div className="header-content help_content">
                                <div className="account_wrap">
                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                        <div className="row">
                                            <Link to={'/profile'}>
                                                <div className="col-md-6 col-sm-5 col-xs-6 white-block block-left">
                                                    <div className="block-content">
                                                        <img src="img/profiles-icon.png" alt="Person Image"/>
                                                        <h2 className="m-t-27">{t('profile')}</h2>
                                                    </div>
                                                </div>
                                            </Link>
                                            <Link to={'/payment/methods'}>
                                                <div className="col-md-6 col-sm-5 col-xs-6 white-block block-right">
                                                    <div className="block-content">
                                                        <img src="img/payment-methods-icon.png" alt="Payment Image"/>
                                                        <h2>{t('payment_methods')}</h2>
                                                    </div>
                                                </div>
                                            </Link>
                                            <Link to={'/order/history'}>
                                                <div className="col-md-6 col-sm-5 col-xs-6 white-block block-left">
                                                    <div className="block-content">
                                                        <img src="img/preferences.png" alt="Preferences Image"/>
                                                        <h2>{t('order_history')}</h2>
                                                    </div>
                                                </div>
                                            </Link>
                                            <Link to={'/helpcenter'}>
                                                <div className="col-md-6 col-sm-5 col-xs-6 white-block block-right">
                                                    <div className="block-content">
                                                        <img src="img/help-icon.png" alt="Help Image"/>
                                                        <h2 className="m-t-27">{t('help')}</h2>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-box">
                                    <form name="" className="" method="post" encType="multipart/form-data" action="#">
                                        <div className="form-group m-b-60">
                                            <input type="button" className="form-control" name="logoutBtn"
                                                   id="logoutBtn"
                                                   onClick={() => {
                                                       this.logout()
                                                   }} value={t('signout')}/>

                                        </div>
                                    </form>
                                </div>
                            </div>
                        </form>
                    </div>
                    <Modal closeOnEsc={false} closeOnOverlayClick={false} showCloseIcon={false} open={open}
                           onClose={this.onCloseModal} center>
                        <h2>&nbsp;&nbsp;&nbsp;&nbsp;Loading...&nbsp;&nbsp;&nbsp;&nbsp;</h2>

                        <p style={{textAlign: 'center'}}>
                            <img width={'40'} height={'40'} src={'/img/loader.gif'}/>
                        </p>
                    </Modal>
                </div>


                <div className="clearfix"></div>

            </div>
        );
    }
}

export default withRouter(withTranslation()(accountSetup));


// WEBPACK FOOTER //
// ./src/view_components/account_setup.js